export const validation = {
  titleMaxChar: 200,
  paragraphMaxChar: 300,
}
